import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inSchoolCartService } from './InSchoolCart.service';
import { getTimeLabel, getTrainingDateRangeLabel } from '../SearchSchool.functions';

export class InSchoolCartItem extends Component {

  constructor(props) {
    super(props);

    this.state = {
      deleting: false,
    };
  }

  _removeCartItem() {
    inSchoolCartService.removeTraining(this.props.training.id_training);
    this.setState({ deleting: true });
  }

  render() {
    const { training } = this.props;

    const timeLabel = getTimeLabel(
      training.general_start_time,
      training.general_end_time
    );

    const dateLabel = getTrainingDateRangeLabel(
      training.datum_start,
      training.datum_eind
    );

    // if the user is deleting the item show a loader
    const deleteIcon = this.state.deleting === true
      ? (<i className="fa fa-circle-o-notch fa-spin"></i>)
      : (<i className="fa fa-times"></i>) ;

    return (
      <li className="school-page__cart-item">
        <div className="school-page__cart-item-body">
          <div className="school-page__cart-item-title">
            {training.vak_naam} {training.vak_niveau}
          </div>
          <div className="school-page__cart-item-subtitle">
            {dateLabel}, {timeLabel}
          </div>
        </div>
        <div className="school-page__cart-item-price">
                    &euro; {training.prijs}
        </div>
        <a className="shopping-cart-icon__item-remove"
          onClick={() => this._removeCartItem()}>
          {deleteIcon}
        </a>
      </li>
    );
  }
}

InSchoolCartItem.propTypes = {
  training: PropTypes.object,
};
